import type { SalesStage } from '../../../api';
import { ONVIZ_JOURNEY_STEPS, journeyIndex } from '../../../lib/onvizOrderJourney';
import { SALES_STAGE_META } from './crmLabels';

type Props = {
  stage: SalesStage;
  orderStatus?: string | null;
  compact?: boolean;
};

export function CrmOrderJourneyRail({ stage, orderStatus, compact }: Props) {
  const activeIdx = journeyIndex(stage);
  const closed = orderStatus === 'delivered' || orderStatus === 'cancelled';

  return (
    <div
      className="rounded-xl p-3 overflow-x-auto"
      style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border-subtle)' }}
    >
      <p className="text-[10px] font-bold uppercase tracking-wide mb-2" style={{ color: 'var(--text-3)' }}>
        Маршрут заказа
      </p>
      <div className="flex items-center gap-0.5 min-w-max pb-1">
        {ONVIZ_JOURNEY_STEPS.map((step, i) => {
          const meta = SALES_STAGE_META[step.stage];
          const done = closed ? i <= activeIdx : i < activeIdx;
          const active = !closed && step.stage === stage;
          return (
            <div key={step.stage} className="flex items-center">
              <div
                className="flex flex-col items-center px-1"
                style={{ minWidth: compact ? 44 : 52 }}
                title={step.managerHint}
              >
                <div
                  className="w-2 h-2 rounded-full mb-1"
                  style={{
                    background: active ? meta.color : done ? 'rgba(104,211,145,0.9)' : 'rgba(255,255,255,0.15)',
                    boxShadow: active ? `0 0 8px ${meta.color}` : undefined,
                  }}
                />
                <span
                  className="text-[8px] font-bold text-center leading-tight"
                  style={{
                    color: active ? meta.color : done ? '#68D391' : 'var(--text-3)',
                  }}
                >
                  {step.label}
                </span>
              </div>
              {i < ONVIZ_JOURNEY_STEPS.length - 1 && (
                <div
                  className="h-px w-2 shrink-0"
                  style={{ background: done ? 'rgba(104,211,145,0.5)' : 'rgba(255,255,255,0.1)' }}
                />
              )}
            </div>
          );
        })}
      </div>
      {orderStatus === 'delivered' && (
        <p className="text-[10px] mt-2 font-semibold" style={{ color: '#68D391' }}>
          ✓ Заказ закрыт — статус «Закрыт · выдан»
        </p>
      )}
    </div>
  );
}
